import { render, staticRenderFns } from "./JhyjDetail2.vue?vue&type=template&id=5eb8905d&scoped=true"
import script from "./JhyjDetail2.vue?vue&type=script&lang=js"
export * from "./JhyjDetail2.vue?vue&type=script&lang=js"
import style0 from "./JhyjDetail2.vue?vue&type=style&index=0&id=5eb8905d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb8905d",
  null
  
)

export default component.exports